import { Text } from '@vtex/admin-ui'
import React from 'react'
import type { FieldError } from 'react-hook-form'

export type FieldErrorTextProps = {
  value: FieldError
}
export const FieldErrorText = ({ value }: FieldErrorTextProps) => {
  return (
    <Text tone="critical" variant="detail">
      {value.message}
    </Text>
  )
}
